import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-599ec02d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "routeSearchMap" }
const _hoisted_2 = { key: 0 }

import { ref, watch, watchEffect, nextTick } from 'vue';
import { pixelBoundsToLatLngBounds } from '@googlemaps/markerclusterer';
import { InfoWindow } from 'vue3-google-map';
import { Map, Icon } from '../../Atoms';
import { RouteItem, OfflineBanner } from '../../Molecules';
import { GoogleMapsRoute, MapBounds, MapPort, RouteServiceStatus } from '../../types';
import { getMapBounds } from '../../helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'RouteSearchMap',
  props: {
    center: {},
    routes: {},
    ports: {},
    onRouteItemClick: { type: Function },
    offline: { type: Boolean },
    isStatusMap: { type: Boolean },
    isStaticMap: { type: Boolean },
    searchResults: {}
  },
  emits: ['onRouteItemClick'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const selectedRoute = ref();
const mapRef = ref();
const portLabels = ref<Array<MapPort>>(props.isStatusMap ? [] : props.ports);
const showLabels = ref(false);
const showRouteItem = ref(false);

const emit = __emit;

function fitToBounds(bounds: MapBounds) {
  const gmap = mapRef.value?.map;
  if (!gmap) return;

  nextTick(() => {
    gmap.fitBounds(
      {
        north: bounds.north,
        east: bounds.east,
        south: bounds.south,
        west: bounds.west,
      },
      {
        padding: 50,  // Adding padding to ensure the route is not cut off at the edges
      }
    );
  });
}

const mapPortLabel = (port) => ({
  name: port.name,
  options: {
    position: {
      lat: port.latitude,
      lng: port.longitude,
    },
  }
});

function handleZoom(newZoom, initialZoom) {
  if (!props.isStatusMap) return;
  if (newZoom < initialZoom && !selectedRoute.value) showLabels.value = false;
}

function focusOnRoute(route) {
  console.log(route);
  const lats = route.ports.map((p) => p.latitude);
  const lngs = route.ports.map((p) => p.longitude);

  const mapBounds = getMapBounds(lats, lngs);
  mapBounds.south = props.isStatusMap ? 2 * mapBounds.south - mapBounds.north : mapBounds.south;

  fitToBounds(mapBounds);
}

function onPolylineClick(route) {
  if (!props.isStatusMap) return;
  showLabels.value = true;
  showRouteItem.value = true;

  selectedRoute.value = route;
  portLabels.value = route.ports.map(mapPortLabel);

  focusOnRoute(route);
}

function routeItemClickHandler() {
  emit('onRouteItemClick', selectedRoute.value.routeCode);
}

const getPortOffset = () => {
  const gmap = mapRef.value?.map;
  const offset = -25 + (gmap ? gmap.getZoom() : 0);
  return offset;
};

watchEffect(() => {
  if (props.searchResults) {
    const ports = props.searchResults.map((item) => item.ports).flat();

    const lats = ports.map((p) => p.latitude);
    const lngs = ports.map((p) => p.longitude);

    const mapBounds = getMapBounds(lats, lngs);

    showLabels.value = true;
    portLabels.value = ports.map(mapPortLabel);

    if (props.searchResults.length < 2) {
      showRouteItem.value = true;
      const route = {
        ...props.searchResults[0],
        name: props.searchResults[0].destinationName,
      };
      selectedRoute.value = route;

      mapBounds.south = 2 * mapBounds.south - mapBounds.north;
    } else {
      showRouteItem.value = false;
    }

    // Needed to add set timeout as if we call fitToBounds too soon the google map is not ready for
    // it and we get unpredictable results. Unfortunately there is nothing we can hook into...
    setTimeout(() => fitToBounds(mapBounds), 500);
  }
});

watch(() => props.ports, (newPorts) => {
  if (!props.isStatusMap && newPorts) portLabels.value = newPorts;
});

watch(() => mapRef.value, (map) => {
  if (!map || props.isStatusMap) return;

  if (props.routes) {
    focusOnRoute(props.routes[0]);
  }
});

watch(() => props.routes, (newRoute) => {
  if (props.isStatusMap || !newRoute) return;

  focusOnRoute(newRoute[0]);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Map), {
      "is-static": _ctx.isStaticMap,
      center: _ctx.center,
      routes: _ctx.routes,
      ports: _ctx.ports,
      onRouteClicked: onPolylineClick,
      onUpdateMapRef: _cache[0] || (_cache[0] = (map) => mapRef.value = map),
      onMapClicked: _cache[1] || (_cache[1] = () => showLabels.value = false),
      onZoomChange: _cache[2] || (_cache[2] = (newZoom, initialZoom) => handleZoom(newZoom, initialZoom))
    }, {
      customPortIcon: _withCtx(() => [
        _createVNode(_unref(Icon), {
          "icon-name": "mapMarker",
          lg: ""
        })
      ]),
      portInfoWindow: _withCtx(() => [
        (showLabels.value || !_ctx.isStatusMap)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(portLabels.value, (port, index) => {
                return (_openBlock(), _createBlock(_unref(InfoWindow), {
                  key: index,
                  class: "portInfoWindow",
                  options: {
              position: {
                lat: port.options.position.lat,
                lng: port.options.position.lng,
              },
              pixelOffset: {
                width: 0,
                height: getPortOffset(),
              },
            }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(port.name), 1)
                  ]),
                  _: 2
                }, 1032, ["options"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-static", "center", "routes", "ports"]),
    (showLabels.value && showRouteItem.value)
      ? (_openBlock(), _createBlock(_unref(RouteItem), {
          key: 0,
          class: _normalizeClass(["routeCard", { isResultCard: _ctx.searchResults }]),
          status: selectedRoute.value.status,
          ports: selectedRoute.value.ports,
          "destination-name": selectedRoute.value.name,
          onClick: routeItemClickHandler
        }, null, 8, ["class", "status", "ports", "destination-name"]))
      : _createCommentVNode("", true),
    (_ctx.offline)
      ? (_openBlock(), _createBlock(_unref(OfflineBanner), { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})